import { isEmbeddedMode } from '@app/core/authentication/embeddedMode/embeddedMode';
import { requestNativeApp } from '@app/core/nativeApps/events/requestNativeApp';
import { PageURL } from '@app/core/widgets/pages';

export const USER_WIZARD_COMPLETION_REQUEST = 'ast.userWizardCompletion';
export const USER_WIZARD_COMPLETION_RESPONSE = 'ast.userWizardCompletionResult';
export const USER_WIZARD_ACTION_CANCEL = 'cancel';

/**
 * Sends the event to native app.
 *
 * @param actionName - optional value which send to native app, e.g. Cancel or Complete
 */
const dispatchWizardCompletionToNativeApp = async (actionName: string) => {
  await requestNativeApp({
    eventId: '',
    requestPayload: {
      action: actionName,
    },
    requestEventType: USER_WIZARD_COMPLETION_REQUEST,
    responseEventType: USER_WIZARD_COMPLETION_RESPONSE,
  });
};

/**
 * Bring user to another page.
 * Usually to Login page.
 */
const navigateTo = (url: string) => {
  window.location.replace(url);
};

/**
 * Performs completion action:
 * - for embedded mode it sends event
 * - for web mode it redirect to Login page
 *
 * @param actionName - optional value which send to native app, e.g. Cancel or Complete
 */
export const processWizardClose = (
  actionName: string = USER_WIZARD_ACTION_CANCEL,
  url: string = PageURL.USER_LOGIN,
) => {
  if (isEmbeddedMode()) {
    dispatchWizardCompletionToNativeApp(actionName);
  } else {
    navigateTo(url);
  }
};
